import { render } from "./OrdersListPage.vue?vue&type=template&id=14cc7ef8&ts=true"
import script from "./OrdersListPage.vue?vue&type=script&lang=ts"
export * from "./OrdersListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__